import { Button, CircularProgress } from "@mui/material"
import HelpIcon from "@mui/icons-material/Help"
import Modal from "react-bootstrap/Modal"

const ReportRegenerateModal = ({ show, onHide, onRegenerate, loading }) => {
  return (
    <Modal show={show} onHide={loading ? undefined : onHide} size="sm" aria-labelledby="report-regenerate-modal" centered>
      <Modal.Header className=" " closeButton={!loading}>
        <Modal.Title id="report-regenerate-modal" className="text-center w-100">
          <HelpIcon style={{ fontSize: "55px", color: "#7C828C" }} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className="text-center">Regenerate Report</h4>
        <p className="text-center">
          This will create a fresh PDF and replace the saved report for this barcode.
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center gap-2">
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <Button variant="outlined" color="warning" className="px-3" onClick={onHide}>
              Cancel
            </Button>
            <Button variant="contained" className="btn_bg_secondery px-3" onClick={onRegenerate}>
              Regenerate
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ReportRegenerateModal
